<template lang='pug'>
  div
    button.copy-code(v-if='isAutoApply' disabled="disabled" v-t='"autoApply"')
    button.copy-code.active(
      v-if='!isAutoApply'
      v-bind:class="{ hidden: isPromoCodeCopied }"
    ) Code:&nbsp;
      b.code.limit-one-lines-text(v-text='promoCodeText')
      a(@click='copyPromoCode')
        svg.btn-icon(class='copy-icon' role='img' title='copy-icons')
    button.copy-code(
      v-if='!isAutoApply'
      v-bind:class="{ hidden: !isPromoCodeCopied }"
      disabled="disabled"
    )
      div(v-t='"copied"')
      a
        svg.btn-icon(class='copy-icon' role='img' title='copy-icons')
</template>

<i18n>
{
  "lng_en": {
    "autoApply": "Auto Apply at Checkout",
    "copied": "Copied!"
  },
  "lng_zh": {
    "autoApply": "結賬時自動申請",
    "copied": "已复制!"
  },
  "lng_th": {
    "autoApply": "ใช้คูปองอัตโนมัติเมื่อชำระเงิน",
    "copied": "คัดลอก!"
  },
  "lng_id": {
    "autoApply": "Terapkan Otomatis saat Checkout",
    "copied": "Disalin!"
  },
  "lng_ko": {
    "autoApply": "결제 시 자동 적용",
    "copied": "복사되었습니다!"
  }
}
</i18n>

<script>
  import { pushDataLayerEvent } from '@/modules/services/gtm'

  export default {
    props: {
      promoCodeText: {
        type: String,
        required: true
      },
      isAutoApply: {
        type: Boolean,
        default: false
      },
      cardSequenceNumber: {
        type: Number,
        default: -1
      },
      parentContainer: {
        type: String,
        default: ''
      }
    },
    computed: {
      trackingEventName () {
        switch (this.parentContainer) {
          case 'promoCodeCard':
            return 'deals_for_you_card_copy_code'
          case 'viewPromoCodeDetails':
            return 'deals_for_you_card_details_copy_code'
          default:
            return ''
        }
      }
    },
    data () {
      return { isPromoCodeCopied: false }
    },
    methods: {
      copyPromoCode () {
        navigator.clipboard.writeText(this.promoCodeText)
        this.isPromoCodeCopied = true
        this.recordClickOnCopyPromoCode()
        setTimeout(() => { this.isPromoCodeCopied = false }, 2000)
      },
      recordClickOnCopyPromoCode () {
        if (this.trackingEventName === '') { return }

        pushDataLayerEvent(
          this.trackingEventName, {
            params: {
              deal_sequence: this.cardSequenceNumber,
              coupon_code: this.promoCodeText
            }
          }
        )
      }
    }
  }
</script>

<style lang='scss' scoped>
  .copy-code {
    margin-top: 6px;
    background-color: $background-blue;
    border-radius: 8px;
    padding: 2px 8px;
    border: none;
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 28px;
    color: $black;
    .btn-icon {
      width: 23px;
      height: 22px;
      margin-left: 5px;
      cursor: pointer;
    }
  }
  .copy-code.hidden {
    display: none;
  }
  .copy-icon {
    background-image: url('../../../assets/images/promo-code/copy-icon.svg');
  }
  .limit-one-lines-text {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    word-break: break-word;
  }
</style>
